import { CircularProgress, Stack } from '@mui/material';
import { MediaButton, MediaButtonLabel } from './styles';
import { ArrowUpIcon } from '@/assets/icons/ArrowUpIcon';
import { ScreenshotIcon } from '@/assets/icons/ScreenshotIcon';
import { useHavePermission } from '@/hooks';
import { Permissions } from '@/types';

type Props = {
  loading: boolean;
  onUploadClick: () => void;
  onCaptureClick?: () => Promise<void>;
  location?: string;
};

export const MediaActionButtons = ({ loading, onUploadClick, onCaptureClick, location }: Props) => {
  const userCanUploadMedia = useHavePermission(Permissions.CREATE_UPLOAD_MEDIA);

  return (
    <Stack direction="row" alignItems="start" gap={1.5} marginY={2}>
      {userCanUploadMedia && (
        <MediaButton
          disabled={loading}
          onClick={onUploadClick}
          variant="outlined"
          id={`${location}-upload-media-button`}
        >
          {loading ? <CircularProgress size={12} /> : <ArrowUpIcon />}
          <MediaButtonLabel>{loading ? 'Uploading' : 'Upload'}</MediaButtonLabel>
        </MediaButton>
      )}

      <MediaButton
        disabled={loading}
        onClick={onCaptureClick}
        variant="outlined"
        id={`${location}-capture-view-button`}
      >
        {loading ? <CircularProgress size={12} /> : <ScreenshotIcon />}
        <MediaButtonLabel>{loading ? 'Capturing' : 'Capture View'}</MediaButtonLabel>
      </MediaButton>
    </Stack>
  );
};
